import { Paper, Typography } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

import { newColors } from 'artkive/utils/theme'

export const PromoCodeLabel = styled(Typography)(({ emphasize = false }) => ({
  fontSize: '14px',
  color: emphasize ? newColors.red[700] : undefined,
}))

export const ReturnArtTip = styled(Paper)({
  backgroundColor: newColors.sky[100],
  padding: '12px 16px',
  fontWeight: 600,
  fontSize: '1rem',
  marginTop: 16,
})

export const SubtitleTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1.25rem',
  color: theme.palette.secondary.dark,
}))
